import CApiHelper from '@frontrow/console/src/entities/helpers/common-api-helper'
import {ajaxJsonCall} from '@freckle/ajax'

import {
  consoleFancyClient,
  extractData,
  type fancyOperations,
  type FancyOk
} from '@frontrow/console/src/open-api/clients'

import {type TeacherLicenseAllocationPostT} from '@frontrow/console/src/models/teacher-license-allocation'
// Datatable
import {type FetchDataParamsT} from '@frontrow/console/src/components/common/data-table'
import {createDatatableUrl} from '@frontrow/console/src/helpers/data-table'

// Not migrated to consoleFancyClient: createDatatableUrl builds an arbitrary
// query string shared by every domain's datatable, and mapping its filters
// onto openapi-fetch's typed `params.query` deserves its own pass across all
// of those domains rather than a one-off cast here.
export function fetchTeachers(
  fetchDataParams?: FetchDataParamsT | null
): Promise<FancyOk<fancyOperations['getTeachersR']>> {
  const baseUrl = CApiHelper.fancyPaths.v2.teachers._0()
  const url = createDatatableUrl(baseUrl, fetchDataParams)
  return ajaxJsonCall({url, method: 'GET'})
}

export async function sendImpersonateTeacher(email: string): Promise<unknown> {
  const {data} = await consoleFancyClient.POST('/2/console/impersonations', {
    body: {teacherEmail: email}
  })
  return data
}

export async function deleteTeacherById(teacherId: number): Promise<unknown> {
  const {data} = await consoleFancyClient.DELETE('/2/teachers/{TeacherR-TeacherId}', {
    params: {path: {'TeacherR-TeacherId': teacherId}}
  })
  return data
}

export async function patchTeacherById(
  teacherId: number,
  patch: unknown
): Promise<FancyOk<fancyOperations['patchTeacherR']>> {
  return extractData(
    await consoleFancyClient.PATCH('/2/teachers/{TeacherR-TeacherId}', {
      params: {path: {'TeacherR-TeacherId': teacherId}},
      body: patch
    })
  )
}

export async function fetchTeacherLicenseAllocations(
  teacherId: number
): Promise<FancyOk<fancyOperations['getTeacherLicenseAllocationsR']>> {
  return extractData(
    await consoleFancyClient.GET(
      '/2/teachers/{TeacherLicenseAllocationsR-TeacherId}/license-allocations',
      {
        params: {
          path: {'TeacherLicenseAllocationsR-TeacherId': teacherId}
        }
      }
    )
  )
}

export async function postTeacherLicenseAllocation(
  teacherId: number,
  newLicense: TeacherLicenseAllocationPostT
): Promise<FancyOk<fancyOperations['postTeacherLicenseAllocationsR']>> {
  return extractData(
    await consoleFancyClient.POST(
      '/2/teachers/{TeacherLicenseAllocationsR-TeacherId}/license-allocations',
      {
        params: {
          path: {'TeacherLicenseAllocationsR-TeacherId': teacherId}
        },
        body: {
          subject: newLicense.subject,
          startsAt: newLicense.startsAt.toISOString(),
          expiresAt: newLicense.expiresAt.toISOString()
        }
      }
    )
  )
}

export async function deleteTeacherLicenseAllocation(licenseId: number): Promise<unknown> {
  const {data} = await consoleFancyClient.DELETE(
    '/2/license-allocations/{LicenseAllocationP-LicenseAllocationId}',
    {
      params: {path: {'LicenseAllocationP-LicenseAllocationId': licenseId}}
    }
  )
  return data
}
